import styled from 'styled-components';

const Subtitle = styled.div`
  border-bottom: 1.5px solid transparent;
  border-image: linear-gradient(to right, rgba(20, 20, 20, 0), rgba(20, 20, 20, 1), rgba(20, 20, 20, 0));
  border-image-slice: 1;
  padding: 5px;
  font-size: 1.3rem;
`;

export default Subtitle;